export default "__VITE_ASSET__f9ASvE4I__"